import { render, staticRenderFns } from "./TableV1Properties.vue?vue&type=template&id=49f98be8&"
import script from "./TableV1Properties.vue?vue&type=script&lang=js&"
export * from "./TableV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports